module.exports = __webpack_public_path__ + "static/media/20_000018.f6a50161.jpg";